import { useEffect, useRef, useState } from "react";
import MainGroupEntry from "./maingroup-entry";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
  GridExpandChangeEvent,
  GridNoRecords,
} from "@progress/kendo-react-grid";

import {
  setExpandedState,
  setGroupIds,
} from "@progress/kendo-react-data-tools";
import { DataResult, process, State } from "@progress/kendo-data-query";
import { useGetMainGroups } from "../../apiclient/product/useGetMainGroupApi";
import { url } from "inspector";
import CategoryModel from "../../models/masters/category-model";
import { SubmitStatus } from "../../core/formik-model-dialog.component";
import { API_END_POINT } from "../../constants";
import { GridCommandCell } from "../../core/grid-command-cell.component";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import {
  DeleteModelDialog,
  DeletePostDataInfo,
  DeleteStatus,
} from "../../core/delete-model-dialog.component";
import MainGroupModel from "../../models/products/maingroup-model";
import ExcelIcon from "../../assets/images/excel-icon";
import { RefreshIcon } from "../../assets/images/refresh-icon";
import EyeIcon from "../../assets/images/eye";
import ReportIcon from "../../assets/images/report";
import FileImg from "../../assets/images/file-image";
import { AddIcon } from "../../assets/images/add-document";
import { GridActionComponent } from "../../core/action.title.component";

export const addOrUpdateArrayItem = (data: any[], item: any, key: string) => {
  const newData = data ? [...data] : [];
  const index = data?.findIndex((d) => d[key] === item[key]);
  console.log("the index is" + index);
  if (index > -1) {
    newData.splice(index, 1, item);
  } else {
    newData.push(item);
  }
  return newData;
};

const MainGroupPage: React.FC = () => {
  const initialDataState: State = {
    take: 10,
    skip: 0,
    group: [],
  };
  const [dataState, setDataState] = useState<State>(initialDataState);
  const [deleteMainGroupData, setDeleteMainGroupData] =
    useState<DeletePostDataInfo>();
  const [collapsedState, setCollapsedState] = useState<string[]>([]);
  const [resultData, setResultData] = useState<DataResult>();

  const [editModal, setEditModal] = useState<boolean>(false);
  const [isViewMode, setViewMode] = useState<boolean>(false);
  const [editData, setEditdata] = useState<MainGroupModel>(null);
  const exportExcel = useRef<ExcelExport | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const {
    data: result,
    isLoading,
    isError,
    refetch: reloadMainGroup,
  } = useGetMainGroups();

  const processWithGroups = (data: MainGroupModel[], dataState: State) => {
    const groups = dataState.group;
    dataState.group = groups;
    const newDataState = process(data, dataState);
    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };

  const fetchData = async () => {
    try {
      setIsRefreshing(true);
      const { data, error } = await reloadMainGroup();
      if (error) {
        console.error("Error reloading:", error);
      } else {
        console.log("Reloaded data:", data);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    setEditdata(null);
    fetchData();
    if (result) {
      setResultData(processWithGroups(result, initialDataState));
    }
  }, [result]);

  let newData: any = null;
  if (resultData) {
    newData = setExpandedState({
      data: resultData.data,
      collapsedIds: collapsedState,
    });
  }

  const onSaveComplete = (status: SubmitStatus, data: MainGroupModel) => {
    setEditdata(null);
    if (status === SubmitStatus.Completed) {
      reloadMainGroup();
      setResultData(processWithGroups(newData, dataState));
    }
  };

  const excelExport = () => {
    if (exportExcel.current !== null) {
      exportExcel.current.save();
    }
  };
  const onAddNew = () => {
    setEditModal(true);
    setViewMode(false);
    setEditdata(new MainGroupModel());
  };

  const onEdit = (data: MainGroupModel) => {
    setViewMode(false);
    setEditModal(true);
    setEditdata(data);
  };

  const onView = (data: MainGroupModel) => {
    setViewMode(true);
    setEditdata(data);
  };

  const onRemove = (data: MainGroupModel) => {
    const { mainGroupId } = data;
    if (mainGroupId > 0) {
      setDeleteMainGroupData({
        data,
        route: `MainGroup/DeleteMainGroup/${mainGroupId}`,
        endpoint: API_END_POINT.PRODUCT,
      });
      reloadMainGroup();
    }
  };
  const onDeleteComplete = (status: DeleteStatus, data: MainGroupModel) => {
    if (status === DeleteStatus.Completed) {
      reloadMainGroup();
      setResultData(processWithGroups(result, dataState));
    }
    setDeleteMainGroupData(null);
  };
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const CommandCell = (props: GridCellProps) => (
    <GridCommandCell
      {...props}
      edit={onEdit}
      remove={onRemove}
      add={onAddNew}
      view={onView}
      dataItem={props.dataItem}
      idPropertyName="mainGroupId"
      editPermissionName={null}
      deletePermissionName={null}
    />
  );

  const onSearch = (e: any) => {
    if (e.target.value.length > 0) {
      const searchKey: string = e.target.value;
      const filteredData = result?.filter((p) =>
        p?.name?.toLowerCase().includes(searchKey?.toLowerCase())
      );
      setResultData(process(filteredData, dataState));
    } else {
      setResultData(process(result, dataState));
    }
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    const item = event.dataItem;

    if (item.groupId) {
      const newCollapsedIds = !event.value
        ? [...collapsedState, item.groupId]
        : collapsedState.filter((groupId) => groupId !== item.groupId);
      setCollapsedState(newCollapsedIds);
    }
  };

  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(result, event.dataState);
    setResultData(newDataState);
    setDataState(event.dataState);
  };
  const onAddClick = () => {
    setEditModal(true);
    setViewMode(false);
    setEditdata(new MainGroupModel());

  };
  let grid = null;
  if (result) {
    grid = (
      <Grid
        data={newData}
        pageable={{ pageSizes: [10, 20, 50, 100] }}
        total={resultData?.total}
        groupable={true}
        sortable={true}
        onDataStateChange={dataStateChange}
        {...dataState}
        onExpandChange={expandChange}
        columnVirtualization={false}
        resizable={true}
      >
        <GridColumn
          field="name"
          title="Name"
          columnMenu={ColumnMenu}
        />

        <GridColumn cell={CommandCell} title="Action" groupable={true} />
        <GridNoRecords>
          <div className="mt-2" style={{ width: "100%", height: "500px" }}>
            <center>
              <h5>No data found</h5>
            </center>
          </div>
        </GridNoRecords>
      </Grid>
    );
    if (isError) {
      return (
        <div>
          <h4>Error Loadong Page..</h4>
        </div>
      );
    }
    return (
      <>
        <div
          style={{ minHeight: "600px" }}
          className="card p-3 border-0 m-3 sw-shadow radius-15"
        >
          <div>
            <GridActionComponent
              onSearchClick={onSearch}
              addButtonClick={onAddClick}
              excelExportClick={excelExport}
              refreshClick={fetchData}
              title="MAIN GROUP"
              addButtonTooltip="Add Main Group"
            ></GridActionComponent>
          </div>

          {editModal && (
            <MainGroupEntry isViewMode={isViewMode} data={editData} onClose={onSaveComplete} />
          )}
             {isViewMode && (
            <MainGroupEntry
              isViewMode={true}
              data={editData}
              onClose={onSaveComplete}
            />
          )}
          {deleteMainGroupData && (
            <DeleteModelDialog
              title="Delete Main Group"
              deleteData={deleteMainGroupData}
              onClose={onDeleteComplete}
            >
              <div>
                Are you sure you want to delete Main Group :{" "}
                <span style={{ fontWeight: "bold" }}>
                  {deleteMainGroupData.data.name}
                </span>
                ?
              </div>
            </DeleteModelDialog>
          )}

          <div>
            <>
              {isRefreshing || isLoading ? (
                <LoadingIndicator isLoading={isRefreshing}></LoadingIndicator>
              ) : (
                <div>
                  {grid}
                  <ExcelExport
                    fileName={"MainGroup_List"}
                    data={result}
                    ref={exportExcel}
                  >
                    <ExcelExportColumn width={100} field="name" title="Name" />
                  </ExcelExport>
                </div>
              )}
            </>
          </div>
          <div></div>
        </div>
      </>
    );
  }
};
export default MainGroupPage;
